export default __webpack_public_path__ + "static/media/boxvideo-compressed-x265.5f4ff2be.mp4";